// @ts-nocheck
const globalAnyWindow = /** @type {any} */ window;
if (!globalAnyWindow.SizeGuideDialog) {
  class SizeGuideDialog extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.dialog = /** @type {HTMLDialogElement | null} */ (this.querySelector('dialog'));
      this.closeButton = /** @type {HTMLElement | null} */ (this.querySelector('[ref="closeButton"]'));
      this.unitToggle = /** @type {HTMLInputElement | null} */ (this.querySelector('[ref="unitToggle"]'));
      this.productTitle = /** @type {HTMLElement | null} */ (this.querySelector('.size-guide-modal__product-title'));
      this.sizeAndFitList = /** @type {HTMLElement | null} */ (this.querySelector('.size-and-fit-wrapper ul'));
      this.unitCells = /** @type {NodeListOf<HTMLElement>} */ (this.querySelectorAll('.size-guide-modal__cell'));
      this.table = /** @type {HTMLTableElement | null} */ (this.querySelector('.size-guide-modal__table'));

      // If data-measurements attribute contains JSON, parse and render
      const raw = this.getAttribute('data-measurements');
      if (raw) {
        this.measurementsData = this.parseMeasurementsJson(raw);
      }

      this.bindEvents();
    }

  bindEvents() {
    if (!this.dialog) return;
    this.closeButton?.addEventListener('click', () => this.closeDialog());
    this.dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
      this.closeDialog();
    });

    // Handle unit toggle
    if (this.unitToggle) {
      this.unitToggle.addEventListener('change', () => this.updateUnits());
    }

    // Close on backdrop click
    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog) {
        this.closeDialog();
      }
    });

    // Keyboard navigation
    this.dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeDialog();
      }
    });
  }

  openDialog() {
    if (!this.dialog) return;
    // If measurements data provided, populate the table now
    if (this.measurementsData && this.table?.dataset && this.table.dataset.driven === 'true') {
      this.populateTableFromData(this.measurementsData);
    }
    this.dialog.showModal();
    this.dialog.setAttribute('open', 'open');

    // Trap focus within dialog
    this.previousActiveElement = document.activeElement;
    this.focusableElements = /** @type {NodeListOf<HTMLElement>} */ (this.dialog.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    ));

    if (this.focusableElements.length > 0) {
      this.focusableElements[0].focus();
    }

    document.body.style.overflow = 'hidden';
  }

  closeDialog() {
    if (!this.dialog) return;

    // Add closing animation class
    this.dialog.classList.add('dialog-closing');

    setTimeout(() => {
      this.dialog?.close();
      this.dialog?.classList.remove('dialog-closing');
      this.dialog?.removeAttribute('open');
      document.body.style.overflow = '';

      // Restore focus
      if (this.previousActiveElement instanceof HTMLElement) {
        this.previousActiveElement.focus();
      }
    }, 300); // Match animation speed
  }

  updateUnits() {
    const useCentimeters = this.unitToggle?.checked;

    if (!this.unitCells) return;
    this.unitCells.forEach((cell) => {
      const inches = cell.dataset.inches;
      const cm = cell.dataset.cm;

      if (useCentimeters && cm) {
        cell.textContent = cm + ' cm';
      } else if (inches) {
        cell.textContent = inches + '"';
      }
    });
  }

  setProductDetails({ title = '', measurementsJson = '', fit = '', modalSize = '' } = {}) {
    if (this.productTitle && title) {
      this.productTitle.textContent = title;
    }

    if (this.sizeAndFitList) {
      let html = '<p class="inner-title">SIZE & FIT</p>';
      if (fit) html += `<li class="inner-details">${fit}</li>`;
      if (modalSize) html += `<li class="inner-details">${modalSize}</li>`;
      this.sizeAndFitList.innerHTML = html;
    }

    if (measurementsJson) {
      this.measurementsData = this.parseMeasurementsJson(measurementsJson);
      if (this.table) {
        if (this.table.dataset) {
          this.table.dataset.driven = 'true';
        }
        this.populateTableFromData(this.measurementsData);
      }
    } else {
      this.measurementsData = null;
    }
  }

  /**
   * @param {string} raw
   */
  parseMeasurementsJson(raw) {
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch {
      return null;
    }
  }

  /**
   * @param {{sizes: any[], measurements: any[]}} data
   */
  populateTableFromData(data) {
    // Expected shape: { sizes: [...], measurements: [{name, values: [...]}, ...] }
    if (!data || !Array.isArray(data.sizes) || !Array.isArray(data.measurements)) return;

    // Build the tbody
    if (!this.table) return;
    const tbody = this.table.querySelector('tbody') || document.createElement('tbody');
    tbody.innerHTML = '';

    data.measurements.forEach((row) => {
      const tr = document.createElement('tr');
      const nameTd = document.createElement('td');
      nameTd.className = 'size-guide-modal__measurement-name';
      nameTd.textContent = row.name;
      tr.appendChild(nameTd);

      (row.values || []).forEach((val) => {
        const td = document.createElement('td');
        td.className = 'size-guide-modal__cell';
        // Store both representations
        if (typeof val === 'object') {
          td.dataset.inches = val.inches ?? '';
          td.dataset.cm = val.cm ?? '';
          td.textContent = val.inches ? (val.inches + '"') : (val.cm ? (val.cm + ' cm') : '');
        } else {
          td.dataset.inches = '' + val;
          td.dataset.cm = '';
          td.textContent = '' + val + '"';
        }
        tr.appendChild(td);
      });

      tbody.appendChild(tr);
    });

    if (!this.table.querySelector('tbody')) this.table.appendChild(tbody);

    // refresh unit cell references
    this.unitCells = this.querySelectorAll('.size-guide-modal__cell');
    // ensure unit toggle updates display accordingly
    if (this.unitToggle) this.updateUnits();
  }

  static openSizeGuide() {
    const dialog = document.querySelector('size-guide-dialog');
    if (dialog) {
      dialog.openDialog();
    }
  }
}

if (!customElements.get('size-guide-dialog')) {
    customElements.define('size-guide-dialog', SizeGuideDialog);
  }

  // Export for use in other scripts
  globalAnyWindow.SizeGuideDialog = SizeGuideDialog;
}
// end guard: only declare once
